import { render, staticRenderFns } from "./DataBody4.vue?vue&type=template&id=0eba9682&"
import script from "./DataBody4.vue?vue&type=script&lang=js&"
export * from "./DataBody4.vue?vue&type=script&lang=js&"
import style0 from "./DataBody4.vue?vue&type=style&index=0&id=0eba9682&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports